import React, { FC, useState } from 'react';
import FnFieldTitle from '../FnFieldTitle';
import { FormGroup, FormTextError } from '../FnInput/styles';
import { FieldInputProps } from 'formik';
import { Textarea } from './styles';
import FnLimitIndicator from '../FnLimitIndicator/index';

type TProps = {
  title?: string;
  field?: FieldInputProps<string>;
  isRequired?: boolean;
  error?: string;
  placeholder?: string;
  maxLength?: number;
};

const FnTextareaField: FC<TProps> = ({
  title = '',
  field,
  isRequired = false,
  error = '',
  placeholder = '',
  maxLength = null
}) => {
  const [currentValueLength, setCurrentValueLength] = useState(field.value ? field.value.length : 0);
  const handleChange = (e) => {
    field.onChange(e);
    if (maxLength) {
      setCurrentValueLength(e.target.value.length);
    }
  };
  return (
    <FormGroup>
      {title && <FnFieldTitle title={title} isRequired={isRequired} />}
      {maxLength && <FnLimitIndicator maxLength={maxLength} length={currentValueLength} />}
      <Textarea {...field} placeholder={placeholder} maxLength={maxLength} onChange={handleChange} />
      {error && <FormTextError>{error}</FormTextError>}
    </FormGroup>
  );
};

export default FnTextareaField;
